import * as React from 'react'
import Joi from 'joi'
import { t } from 'i18next'
import { FileCopy as CopyIcon } from '@mui/icons-material'
import apikey_ from '../../sass/apikey.module.sass'
import { useDispatch, useSelector } from '../../store'
import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogTitle,
  Divider,
  FormControl,
  FormLabel,
  Grid,
  IconButton,
  InputAdornment,
  OutlinedInput,
  Stack,
  Tooltip, useTheme,
} from '@mui/material'
import { ErrorsState, validateForm } from '../../function/validation'
import { FormError } from '../../component/FormError'

import { clearFieldError } from '../../store/common/actionCreator'
import {  BlackListPhones } from '../../store/blacklist/reducer'
import {  editBlackListPhones, postBlackListPhones } from '../../store/blacklist/actionCreator'

type MouseEvent =
  | React.MouseEvent<HTMLAnchorElement>
  | React.MouseEvent<HTMLButtonElement>

const schemaGenerate = Joi.object({
  length: Joi.number().required().min(16).max(32).integer(),
})
const schemaCreate = Joi.object({
  length: Joi.number().required().min(16).max(32).integer(),
  // domains: Joi.array().min(1).label(t('field.label.allowedDomains'))
})
const schemaEdit = Joi.object({
  length: Joi.number().required().min(16).max(32).integer(),
  key: Joi.string().required(),
  // domains: Joi.array().min(1).label(t('field.label.allowedDomains')),
})

type Props = {
  mode: 'create' | 'edit'
  onClose: () => void
  data?: BlackListPhones
}

export const PopupCRUDPhones = ({ mode, onClose, data }: Props) => {
  const dispatch = useDispatch()
  const theme = useTheme()

  const [phone, setPhone] = React.useState(data?.phone || "")
  
  const [errors, setErrors] = React.useState<ErrorsState>(null)

  const [disableGenerate, setDisableGenerate] = React.useState(false)
  const [disableSave, setDisableSave] = React.useState(true)

  function handleSubmit() {
    if (mode === 'create') {
        const requestData = {
          phone: phone,
        }
        dispatch(postBlackListPhones(requestData))
        onClose()
    } else {
      const error = validateForm(schemaEdit, { phone })
        const requestData = {
          id: data?.id as number,
          phone: phone,
        }
        dispatch(editBlackListPhones(requestData))
        onClose()
    }
  }

  React.useEffect(() => {
    setErrors(null)
    dispatch(clearFieldError)
  }, [dispatch, phone])

  return (
    <form onSubmit={handleSubmit} noValidate>
      <Dialog open={true} fullWidth onClose={onClose} maxWidth="md">
        {mode === 'create' && (
          <DialogTitle>Add to Black List</DialogTitle>
        )}
        {mode === 'edit' && <DialogTitle>Edit Black List</DialogTitle>}

        <Divider variant="popup" color="primary" />

        <Stack spacing={2}>
          <Grid container>
            <Grid item xs={5}>
              <FormLabel>phone</FormLabel>
            </Grid>
            <Grid item xs={7}>
              <FormControl fullWidth>
                <OutlinedInput
                  type="string"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
               
              </FormControl>
            </Grid>
          </Grid>

          {mode === 'edit' && (
            <Grid container>
              <Grid item xs={5}>
                <FormLabel>{t('apiKey.key')}</FormLabel>
              </Grid>
              <Grid item xs={7}>
                <FormControl fullWidth>
                  <OutlinedInput
                    value={phone}
                    placeholder={t('apiKey.hint')}
                    readOnly
                  />
                </FormControl>
              </Grid>
            </Grid>
          )}
        </Stack>

        <Divider variant="popup" color="primary" />

        <DialogActions sx={{
          [theme.breakpoints.only("xs")]: {
            //flexDirection: 'column',
          },
        }}>
          <Button
            color="primary"
            size="large"
            onClick={onClose}
            variant="outlined"
          >
            {t('common.close')}
          </Button>
          {mode === 'edit' && (
            <Button
              color="primary"
              variant="contained"
              size="large"
              disabled={disableGenerate}
              sx={{
                [theme.breakpoints.only("xs")]: {
                  fontSize: '10px',
                },
              }}
            >
              {t('common.generate')}
            </Button>
          )}

          <Button
            color="primary"
            variant="contained"
            size="large"
            onClick={handleSubmit}
            disabled={mode === 'edit' ? disableSave : false}
          >
            {t('common.save')}
          </Button>
        </DialogActions>
      </Dialog>
    </form>
  )
}
